<template>
  <div>
    <h1>Receipts diary</h1>
    <v-card>
      <v-card-title v-if="computedReceipts.length">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          outline
        />
      </v-card-title>
      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="computedReceipts"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <v-btn :to="{name:'receipt', params:{id:props.item.id}}" small>{{ props.item.id }}</v-btn>
            </td>
            <td>
              <FileZ :file="props.item.file" v-if="props.item.file" />
              <span v-if="!props.item.file">{{props.item.freereference}}</span>
            </td>
            <td>{{ props.item.sender }}</td>
            <td>{{ props.item.senderreference }}</td>
            <td>{{ props.item.bacs }}</td>
            <td style="text-align:right;">{{ props.item.amount | toCurrency }}</td>
          </tr>
        </template>
        <template v-slot:footer v-if="computedTotal">
          <td colspan="5">
            <strong>Total</strong>
          </td>
          <td style="text-align:right;">{{computedTotal | toCurrency}}</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ReceiptsDiary",
  metaInfo() {
    return {
      title: "Receipts diary",
      titleTemplate: "%s - Fundview - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { FileZ },
  computed: {
    computedReceipts() {
      if (!this.receipts) {
        return [];
      }
      return this.receipts.map(r => {
        const file = this.files ? this.files[r.fileid] : undefined;
        return { ...r, file };
      });
    },
    computedTotal() {
      if (!this.receipts) {
        return null;
      }
      return this.receipts.reduce((total, obj) => obj.amount + total, 0);
    }
  },
  data() {
    return {
      receipts: null,
      files: null,
      search: "",
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "File",
          value: "file.referencelong"
        },
        {
          text: "Sender",
          value: "sender"
        },
        {
          text: "Reference",
          value: "senderreference"
        },
        {
          text: "Bacs",
          value: "bacs"
        },
        {
          text: "Amount",
          value: "amount",
          align: "right"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchReceipts() {
      nbmlaw
        .get(`/cors/admin/fundview/receipts/diary`, {
          params: { date: this.$route.query.date }
        })
        .then(response => {
          // console.log(response.data);
          this.receipts = response.data;
        })
        .catch(() => {});
    },
    fetchFiles() {
      nbmlaw
        .get(`/cors/admin/fundview/receipts/diary/files`, {
          params: { date: this.$route.query.date }
        })
        .then(response => {
          // console.log(response.data);
          this.files = response.data;
        })
        .catch(() => {});
    }
  },
  watch: {
    "$route.query.date": {
      immediate: true,
      handler() {
        this.fetchReceipts();
        this.fetchFiles();
      }
    }
  }
};
</script>
